import { GoogleLogin } from '@react-oauth/google';
import AppleLogin from 'react-apple-login';
import { useSearchParams } from 'react-router-dom';
import {useAuth} from "../../../../hooks/useAuth";
import useImage from '../../../../hooks/useImage';
import { LoginWith } from '../../../../modules/authorization/authorization.type';
import Button from '../../../../ui/button';
import { WalletOptions } from '../../../WagmiWrp/WalletOptions/WalletOptions';
import './styles.scss';
import React from 'react';

export const LoginWithPiece: React.FC<{ loginWith: LoginWith | undefined }> = ({
  loginWith,
}) => {
  const [searchParams] = useSearchParams();
  const APPLECLIENTID = 'io.pandamr.space';
  const icons: { [key: string]: string } = {
    google: useImage('logos/google-logo.png').image,
    apple: useImage('logos/apple-logo.png').image,
    fastex: useImage('logos/fastex.png').image,
  };

  const {setGoogleLogin, setAppleLogin} = useAuth(searchParams);

  if (loginWith) {
    return (<>
      <p className="popupAuthText">Or sign in using</p>
      <div className="modalSocialLinks">
        <div
            style={{
              position: 'relative',
            }}
        >
          <div className="google-login-wrapper">
            <GoogleLogin
                onSuccess={(response: any) => {
                  setGoogleLogin(response);
                }}
                onError={() => {
                  console.log('Login Failed');
                }}
            />
          </div>
          <Button
              type="rounded-15"
              size="w100 lg"
              color="roundedSecondary"
          >
            <img className="buttonImage" src={icons.google} alt="google" />
            <span>Google Account</span>
          </Button>
        </div>
        {!(navigator.userAgent.indexOf('Mac OS X') !== -1) && (<AppleLogin
            clientId={APPLECLIENTID}
            redirectURI={`${window.location.origin}`}
            usePopup
            callback={(response) => setAppleLogin(response)}
            scope="email name"
            render={(renderProps) => (<Button
                onClick={renderProps.onClick}
                type="rounded-15"
                size="w100 lg"
                color="roundedSecondary"
            >
              <img className="buttonImage" src={icons.apple} alt="apple" />
              <span>Apple ID</span>
            </Button>)}
        />)}
        <WalletOptions />
      </div>
    </>
    );
  }
  return <></>;
};
